<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-baseline justify-between gap-4">
      <span :id="`${id}-label`" class="text-base font-medium text-heading">{{ label }}</span>
      <span class="text-base whitespace-nowrap text-muted">
        {{ modelValue }} {{ modelValue === 1 ? 'persoon' : 'personen' }}
      </span>
    </div>
    <div class="flex w-full gap-3" role="group" :aria-labelledby="`${id}-label`">
      <button
        v-for="count in options"
        :key="count"
        type="button"
        :aria-label="`${count} ${count === 1 ? 'persoon' : 'personen'}`"
        :aria-pressed="modelValue === count"
        class="flex h-[72px] flex-1 cursor-pointer items-center justify-center rounded-lg border focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-bright"
        :class="
          count <= modelValue
            ? 'border-blue-bright bg-blue-tint text-blue-bright'
            : 'border-line-soft bg-white text-line-strong'
        "
        @click="emit('update:modelValue', count)"
      >
        <PersonIcon class="h-[33px]" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import PersonIcon from '@/assets/svg/person.svg?component'

defineProps<{
  id: string
  label: string
  /** One tile per household size; everything up to the chosen size lights up, like the design. */
  options: number[]
  modelValue: number
}>()

const emit = defineEmits<{ 'update:modelValue': [value: number] }>()
</script>
